/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Grid, Typography } from '@mui/material'
import { connect } from 'react-redux'
import GoogleMapImage from '../../../../assets/images/navigation/googlemap.png'
import BaladImg from '../../../../assets/images/navigation/balad.png'
import IntlMessages from '../../../../util/IntlMessages'
import { navigationLink } from '../../../../util/tools'
import useStyles from './style'

function Navigation(props) {
    const classes = useStyles()

    let data = [
        {
            link: navigationLink(props.latitude, props.longitude, 'balad'),
            image: BaladImg,
            title: <IntlMessages id="balad" />
        },
        {
            link: navigationLink(props.latitude, props.longitude, 'google'),
            image: GoogleMapImage,
            title: <IntlMessages id="googleMap" />
        }
    ]

    return (
        <Grid container spacing={2} className={classes.rootNavigator}>
            {data.map((obj, index) => (
                <Grid onClick={() => window.location.assign(obj.link)} item xs={4} md={4} key={index}>
                    <img className={classes.image} src={obj.image} alt="pido" />
                    <Typography className={classes.imageTitle}>
                        {obj.title}
                    </Typography>
                </Grid>
            ))}
        </Grid>
    )
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Navigation)